import { type Meta } from '../types/docs';

const META: Meta = {
  name: 'viewed_recently_deleted_page',
  description: 'User viewed recently deleted page',
};

export default META;
